export default "__VITE_ASSET__CI60LKeJ__"